import type React from 'react';
import { useMemo } from 'react';

import { Text } from '@change/ds-core-ui';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { usePageCopy } from 'src/app/pages/psf/promoteOrShare/shared/hooks';
import { Html } from 'src/app/shared/components/html';

import { ExtendedComboCopy } from '../ExtendedComboCopy';

export const ComboStory: React.FC = () => {
	const {
		data: { subheadingText2, subheadingContributionHero, subheadingContributionNone, subheadingText3 },
	} = usePageCopy();

	const {
		data: {
			petition: { promotionStats },
			revenueLongerComboCopyExperiment,
		},
	} = usePsfPromoteOrSharePageData();

	const showImpactBox = promotionStats.signatureCount > 1;
	const impactBox = useMemo(
		() => (
			<Html
				as="div"
				html={subheadingContributionHero || subheadingContributionNone}
				className="text-typography-weak mt-7 md:mt-9 md:text-lg"
			/>
		),
		[subheadingContributionHero, subheadingContributionNone],
	);

	if (revenueLongerComboCopyExperiment.variation === 'variant_1') {
		return (
			<>
				<ExtendedComboCopy />
				{showImpactBox && impactBox}
			</>
		);
	}

	if (!subheadingText3) {
		return <Html as="div" html={subheadingText2} className="text-base md:text-lg" />;
	}

	return (
		<>
			<Text as="h2" variant="heading" size="medium" className="mb-3 md:mb-4">
				{subheadingText2}
			</Text>
			<Text className="text-typography-weak md:text-lg">{subheadingText3}</Text>
			{showImpactBox && impactBox}
		</>
	);
};
